import React, { useContext } from 'react';

import { cerise } from '@vimeo/iris/color';
import { StandardFooter } from '@vimeo/ui/core';
import { ViewerContext } from '@vimeo/viewer';

import TopNavigation from '../_components/Navigations/TopNavigation';

const HomePageLayout = ({ children }: { children: React.ReactNode }) => {
  const viewer = useContext(ViewerContext);
  return (
    <>
      <TopNavigation backgroundColor={cerise(40)} />
      {children}
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <StandardFooter {...(viewer as any)} absoluteUrl />
    </>
  );
};
export default HomePageLayout;
